import { AfterViewInit, Component, ElementRef, Inject, Input, PLATFORM_ID, ViewChild } from '@angular/core';
import { DirectionService } from '../../../shared/services/direction.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-block-posts',
    templateUrl: './block-posts.component.html',
    styleUrls: ['./block-posts.component.scss']
})
export class BlockPostsComponent implements AfterViewInit {
    @Input() header = '';
    @Input() layout: 'list-sm'|'grid-nl' = 'list-sm';
    @Input() posts: any[] = [];

    @ViewChild('container', {read: ElementRef}) container: ElementRef;

    showCarousel = true;

    carouselDefaultOptions = {
        margin: 30,
        nav: false,
        dots: false,
        loop: true,
        rtl: this.direction.isRTL()
    };

    carouselOptionsByLayout = {
        'grid-nl': {
            responsive: {
                930: {items: 3},
                690: {items: 2},
                0: {items: 1}
            }
        },
        'list-sm': {
            responsive: {
                930: {items: 2},
                0: {items: 1}
            }
        }
    };

    // Built ONCE per layout and handed to owl by the same reference every time. owl-carousel-o
    // compares the options input by reference in ngOnChanges and, on any change, tears the
    // carousel down and re-initialises every slide. A getter that returned a fresh object did
    // that on EVERY change detection pass - each click, scroll and timer rebuilt every carousel
    // on the page, which is what made the browser crawl and hang after the page had loaded.
    private builtOptions: any = null;
    private builtForLayout: string = null;
    get carouselOptions(): any {
        if (!this.builtOptions || this.builtForLayout !== this.layout) {
            const options = Object.assign({}, this.carouselDefaultOptions, this.carouselOptionsByLayout[this.layout]);

            // Server-side render: no clones. `loop` makes owl render enough EXTRA copies of the
            // slides to fill the wrap-around, and they are real markup in the page the server
            // sends - three posts came out as seven cards, so every title and summary was read
            // two or three times over by whatever crawled the home page. The animation those
            // clones exist for never runs on the server. The browser builds the carousel again
            // with the real options, so the visitor sees no change.
            if (!isPlatformBrowser(this.platformId)) {
                options.loop = false;
            }

            this.builtForLayout = this.layout;
            this.builtOptions = options;
        }
        return this.builtOptions;
    }

    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private direction: DirectionService
    ) { }

    ngAfterViewInit(): void {
        // No posts, no container (it is drawn with them): nothing to measure.
        if (isPlatformBrowser(this.platformId) && this.container) {
            const container = this.container.nativeElement as HTMLElement;
            const containerWidth = container.getBoundingClientRect().width;

            window.addEventListener('load', () => {
                const newContainerWidth = container.getBoundingClientRect().width;

                if (containerWidth !== newContainerWidth) {
                    this.showCarousel = false; 
                    setTimeout(() => this.showCarousel = true, 0);
                }
            },{passive:true});
        }
    }
}
